/** Canonical database creation wizard */
export const DATABASE_NEW_PATH = '/database/new'

/** Link an org database that already exists (preview data / seed sync). */
export const DATABASE_CONNECT_PATH = '/database/connect'

export function databaseNewPath(
  projectId?: number | string | null,
  opts?: { fromProjectOnboarding?: boolean; connectionMode?: 'cloud' | 'self_hosted' },
): string {
  let path = DATABASE_NEW_PATH
  if (projectId != null && projectId !== '') {
    const id = typeof projectId === 'number' ? projectId : parseInt(String(projectId), 10)
    if (Number.isFinite(id) && id > 0) {
      path = `${DATABASE_NEW_PATH}?projectId=${id}`
    }
  }
  if (opts?.fromProjectOnboarding) {
    path += path.includes('?') ? '&fromProjectOnboarding=1' : '?fromProjectOnboarding=1'
  }
  if (opts?.connectionMode === 'cloud' || opts?.connectionMode === 'self_hosted') {
    path += path.includes('?') ? `&connectionMode=${opts.connectionMode}` : `?connectionMode=${opts.connectionMode}`
  }
  return path
}

export function databaseConnectPath(
  projectId?: number | string | null,
  opts?: { fromProjectOnboarding?: boolean },
): string {
  let path = DATABASE_CONNECT_PATH
  if (projectId != null && projectId !== '') {
    const id = typeof projectId === 'number' ? projectId : parseInt(String(projectId), 10)
    if (Number.isFinite(id) && id > 0) {
      path = `${DATABASE_CONNECT_PATH}?projectId=${id}`
    }
  }
  if (opts?.fromProjectOnboarding) {
    path += path.includes('?') ? '&fromProjectOnboarding=1' : '?fromProjectOnboarding=1'
  }
  return path
}

/** @deprecated Use databaseConnectPath with existing=1 URLs */
export function legacyDatabaseOnboardingTarget(search: string): string {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  if (params.get('existing') === '1') {
    params.delete('existing')
    const qs = params.toString()
    return qs ? `${DATABASE_CONNECT_PATH}?${qs}` : DATABASE_CONNECT_PATH
  }
  const qs = params.toString()
  return qs ? `${DATABASE_NEW_PATH}?${qs}` : DATABASE_NEW_PATH
}
